import { Box } from "@mui/material";
import MemberContent from "./components/memberContent";

const MemberConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <MemberContent />
    </Box>
  );
};

export default MemberConnectPage;
